module.exports = __webpack_public_path__ + "media/images/icons/filled/copyright-circle-11ffde699f205fff5567e0af9ab24cd8.svg";